import React, { useEffect, useRef } from "react";
import classes from "./SuccessMessage.module.css";
import Container from "../../UI/Container/Container";
import image from "../../../assets/images/old-west--alumni.jpg";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const SuccessMessage = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const overlayRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: overlayRef.current,
        start: "top 50%",
      },
    });

    timeline.to(overlayRef.current, {
      opacity: 1,
      duration: 0.5,
      ease: "sine.out",
    });
  });

  return (
    <div className={classes.SuccessMessage}>
      <img src={image} alt="Old West" />
      <div ref={overlayRef} className={classes.Overlay}>
        <Container>
          <p>
            We are focused on preparing our grads for whatever comes next. In fact,
            96% are employed, in grad school, completing an
            internship or pursuing a fellowship within one year, and 95% of
            medical school and 94% of law school applicants were admitted.
          </p>
          <p>
            Our graduates have an edge, one that leads them to launch careers on
            Wall Street, in Silicon Valley and at locations across the globe.
            They serve with Teach for America, the Peace Corps and governmental
            agencies.
          </p>
          <p>
            They embark on bold entrepreneurial ventures that change the world.
            They live at the tops of their fields, in business, tech, science
            and medicine, finance, art, education and entertainment. Their
            successes reflect a significant return on investment in a Dickinson
            education.
          </p>
        </Container>
      </div>
    </div>
  );
};

export default SuccessMessage;
